import React from "react";

const Leadgen = () => {
  return (
    <section className="leadgensection">
      <h1 className="leadgenh1">
        BUSINESS GURU - Your Trusted Partner in Marketing and Lead Generation!
      </h1>
      <div className="service-process-div">
        <div className="service-toWhom-text">
          <h1>1. End-to-End Delivery</h1>
          <h2>
            We take ownership of the entire process thereby ensuring end-to-end
            delivery, which typically ends with an introductory online meeting
            with the prospect.
          </h2>
        </div>
        <div className="service-toWhom-text">
          <h1>2. Expertise Across Verticals</h1>
          <h2>
            Our Practice Leaders, each having 25+ years of rich experience, lead
            the Sales, Marketing and Customer Success verticals. These industry
            stalwarts bring unparalleled insights and knowledge to the table.
          </h2>
        </div>
        <div className="service-toWhom-text">
          <h1>3. Diverse Lead Sources</h1>
          <h2>
            We aggregate leads from diverse sources – responsive emails,
            professional social media and personal contacts in various industry
            associations.
          </h2>
        </div>
        <div className="service-toWhom-text">
          <h1>4. Tailored Approach</h1>
          <h2>
            Our journey with you always begins by understanding your specific
            business needs. We meticulously curate a marketing strategy that
            seamlessly integrates with our lead generation services, ensuring
            the highest return on investment possible. Secondly, we can even
            tailor our lead generation packages to fit within your budget
            constraints.
          </h2>
        </div>
        <div className="service-toWhom-text">
          <h1>5. Transparent Communication</h1>
          <h2>
            The Business Guru stamp is synonymous with transparency – we believe
            in keeping our clients informed every step of the way, thereby
            fostering an environment of trust and collaboration. We are
            committed to delivering the targeted number of leads, all of which
            are of high quality, which in turn are expected to ensure high
            conversion rates.
          </h2>
        </div>
      </div>
    </section>
  );
};

export default Leadgen;
